module.exports = __webpack_public_path__ + "static/media/dashboard-backdrop.3344d4ce.png";